import api from "@/api";

export default {
    namespaced: true,

    state: {},

    actions: {
        async createComment(context, {voteId, commentText, feedbackEmail, feedbackPhotos, feedbackAudio}) {
            console.log('voteId, commentText', voteId, commentText, feedbackEmail)
            const prefix = context.rootState.auth.accessToken ? 'v1/' : ''
            let formData = new FormData();
            formData.append('date', (new Date()).toISOString());
            formData.append('comment', commentText);
            formData.append('contact_info', feedbackEmail);
            for (var i = 0; feedbackPhotos.length > i; i++) {
                formData.append('file[]', feedbackPhotos[i]);
            }
            formData.append('audio', feedbackAudio);

            let url = `/api/${prefix}votes/${voteId}/attachments`;

            let forceToken = context.rootState.auth.accessToken || context.rootState.auth.anonymousToken || localStorage.getItem('anonymous_token')
            return await api.request("post", url, formData, null, forceToken);
        },
        async attachPhoto(context, {voteId, photo, sldText}) {
            const prefix = context.rootState.auth.accessToken ? 'v1/' : ''
            let formData = new FormData();
            formData.append('date', (new Date()).toISOString());
            formData.append('sld_text', sldText);
            formData.append('file[]', photo);
            let url = `/api/${prefix}votes/${voteId}/attachments/photo`;

            let forceToken = context.rootState.auth.accessToken || context.rootState.auth.anonymousToken || localStorage.getItem('anonymous_token')
            return await api.request("post", url, formData, null, forceToken);
        },
        async detachPhoto(context, {voteId, photoUid}) {
            const prefix = context.rootState.auth.accessToken ? 'v1/' : ''
            let url = `/api/${prefix}votes/${voteId}/attachments/photo/${photoUid}`;
            let forceToken = context.rootState.auth.accessToken || context.rootState.auth.anonymousToken || localStorage.getItem('anonymous_token')
            return await api.request("delete", url, null, null, forceToken);
        },
        async sendContactInfo(context, {voteId, contactInfo}) {
            const prefix = context.rootState.auth.accessToken ? 'v1/' : ''
            let body = {
                contact_info: contactInfo
            }
            let url = `/api/${prefix}votes/${voteId}/contactInfo`;
            let forceToken = context.rootState.auth.accessToken || context.rootState.auth.anonymousToken || localStorage.getItem('anonymous_token')
            return await api.request("post", url, body, null, forceToken);
        }
    }
};
